import { render, staticRenderFns } from "./PriceChange.vue?vue&type=template&id=769b7c36&"
var script = {}
import style0 from "./PriceChange.vue?vue&type=style&index=0&id=769b7c36&prod&class=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports